import type { SnapshotEventReminderFrequency } from "@/modules/snapshots/businessReports.types";

export const REMINDER_UNIT_OPTIONS: { value: SnapshotEventReminderFrequency; label: string }[] = [
  { value: "DAILY", label: "day(s)" },
  { value: "WEEKLY", label: "week(s)" },
  { value: "MONTHLY", label: "month(s)" },
  { value: "YEARLY", label: "year(s)" },
];
